import { useSearchParams } from 'react-router-dom';

import { COMPONENTS_TABLE_PAGE_SIZE } from '../shared/constants/products.constant';
import { parseString } from '../shared/helpers/url-parameter-parser';
import { GetComponentsParams } from './api/components';

type ComponentsTableQueryState = {
  skip: number;
  size: number;
  filters: Partial<GetComponentsParams>;
  sort: string | undefined;
  setParams: (params: Record<string, string | number | string[] | undefined>) => void;
};

export const useComponentsTableQueryParams = (): ComponentsTableQueryState => {
  const [sp, setSp] = useSearchParams();

  // Pagination
  const skip =
    (Number(sp.get('page') ?? 1) - 1) * Number(sp.get('size') ?? COMPONENTS_TABLE_PAGE_SIZE);
  const size = Number(sp.get('size') ?? COMPONENTS_TABLE_PAGE_SIZE);

  // Sorting
  const sort = sp.get('sort') ?? '';

  // Filters
  const filters: Partial<GetComponentsParams> = {
    status: parseString(sp.get('status')),
    region: parseString(sp.get('region')),
    search: parseString(sp.get('search')),
    country: parseString(sp.get('country')),
  };

  // Function to set multiple URL params at once
  const setParams = (params: Record<string, string | number | string[] | undefined>): void => {
    const next = new URLSearchParams(sp);

    Object.entries(params).forEach(([key, value]) => {
      if (value === undefined || (Array.isArray(value) && value.length === 0) || value === '') {
        next.delete(key);

        return;
      }

      if (Array.isArray(value)) {
        next.set(key, value.join(','));

        return;
      }

      next.set(key, String(value));
    });

    setSp(next, { replace: true });
  };

  return {
    skip,
    size,
    sort,
    filters,
    setParams,
  };
};
